import graphql from "babel-plugin-relay/macro";
import { useMutation } from "react-relay";

import {
  ClaimMemberRoundInBookingInput,
  useMemberJoinNonPrePaidBookingMutation,
} from "./__generated__/useMemberJoinNonPrePaidBookingMutation.graphql";

export const useMemberJoinNonPrePaidBooking = () => {
  const [joinNonPrePaidBookingMutation, isJoiningNonPrePaidBooking] =
    useMutation<useMemberJoinNonPrePaidBookingMutation>(
      useMemberJoinNonPrePaidBookingMutationString
    );

  const handleMemberJoinNonPrePaidBooking = (
    input: ClaimMemberRoundInBookingInput,
    handleJoinSuccess: (slotOrBookingId: string) => void,
    handleJoinError: () => void
  ) => {
    joinNonPrePaidBookingMutation({
      variables: { input },
      onCompleted: (response) => {
        if (
          response?.claimMemberRoundInBooking?.success &&
          response?.claimMemberRoundInBooking?.booking?.id
        ) {
          handleJoinSuccess(response.claimMemberRoundInBooking.booking.id);
        } else {
          handleJoinError();
        }
      },
      onError: () => {
        handleJoinError();
      },
    });
  };

  return { handleMemberJoinNonPrePaidBooking, isJoiningNonPrePaidBooking };
};

export const useMemberJoinNonPrePaidBookingMutationString = graphql`
  mutation useMemberJoinNonPrePaidBookingMutation(
    $input: ClaimMemberRoundInBookingInput!
  ) {
    claimMemberRoundInBooking(input: $input) {
      success
      errors {
        field
        code
        message
      }
      booking {
        id
      }
    }
  }
`;
